import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export enum DelayKeys {
  MyMonitoringNotificationPrompt = 'mm-notification-prompt',
  PortalNotificationPrompt = 'portal-notification-prompt'
}

interface INotificationDelayStore {
  delays: Record<string, number>
  setDelay: (key: string, delayMs: number) => void
  clearDelay: (key: string) => void
  isDelayed: (key: string) => boolean
  getRemainingMs: (key: string) => number
  clearAll: () => void
}

export const useNotificationDelayStore = create<INotificationDelayStore, [['zustand/persist', unknown]]>(
  persist(
    (set, get) => ({
      delays: {},
      setDelay: (key, delayMs) => {
        const until = Date.now() + Math.max(delayMs, 0)
        set((state) => ({ delays: { ...state.delays, [key]: until } }))
      },
      clearDelay: (key) => {
        set((state) => {
          if (!state.delays[key]) return state
          const next = { ...state.delays }
          delete next[key]
          return { delays: next }
        })
      },
      isDelayed: (key) => {
        const until = get().delays[key]
        if (!until) return false
        if (until <= Date.now()) {
          get().clearDelay(key)
          return false
        }
        return true
      },
      getRemainingMs: (key) => {
        const until = get().delays[key]
        if (!until) return 0
        const remaining = until - Date.now()
        if (remaining <= 0) {
          get().clearDelay(key)
          return 0
        }
        return remaining
      },
      clearAll: () => set({ delays: {} })
    }),
    {
      name: 'app-notification-delays'
    }
  )
)
